import { atom } from 'recoil';

export const cookingTabAtom = atom({
	key: 'cookingTab',
	default: 'preparation' as 'alchemy' | 'cooking' | 'preparation',
});
